
import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

export const CATEGORY_TABS = [
  { id: 'all', label: 'All News' },
  { id: 'financial', label: 'Financial' },
  { id: 'leadership', label: 'Leadership' },
  { id: 'product', label: 'Products' },
  { id: 'market', label: 'Market' }
];

interface CategoryTabsProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  children: React.ReactNode;
}

const CategoryTabs = ({ selectedCategory, onCategoryChange, children }: CategoryTabsProps) => {
  return (
    <Tabs defaultValue="all" value={selectedCategory} className="w-full">
      <TabsList className="mb-6 w-full justify-start overflow-auto">
        {CATEGORY_TABS.map((tab) => (
          <TabsTrigger 
            key={tab.id} 
            value={tab.id}
            onClick={() => onCategoryChange(tab.id)}
            className="px-4"
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value={selectedCategory} className="mt-0">
        {children}
      </TabsContent>
    </Tabs>
  );
};

export default CategoryTabs;
